import type { QueryKey } from '@tanstack/vue-query'
import { MutationCache, QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import { h } from 'vue'
import { toast } from 'vue-sonner'

export default defineNuxtPlugin((nuxtApp) => {
  const queryClient = new QueryClient({
    mutationCache: new MutationCache({
      onSuccess: (_data, _variables, _context, mutation) => {
        const successMessage = mutation.meta?.successMessage as string | undefined
        if (successMessage) {
          toast.success('Berhasil', {
            duration: 3000,
            description: successMessage,
          })
        }
      },
      onError: (error: any, _variables, _context, mutation) => {
        const errorMessage = mutation.meta?.errorMessage as string | undefined
        const errorDynamic = error?.meta?.message || error?.message
        if (error?.data && typeof error.data === 'object') {
          const validationErrors: string[] = []
          Object.values(error.data).forEach((fieldErrors: any) => {
            if (Array.isArray(fieldErrors)) {
              validationErrors.push(...fieldErrors)
            }
          })
          if (validationErrors.length > 0) {
            const description = h('div', { class: 'space-y-1' }, validationErrors.map((msg, index) =>
              h('div', { key: index }, `${index + 1}. ${msg}`),
            ))
            toast.error('Gagal', {
              duration: 4000,
              description,
            })
            return
          }
        }

        if (errorMessage) {
          toast.error(errorMessage)
        }
        else if (errorDynamic) {
          toast.error('Gagal', {
            duration: 2000,
            description: errorDynamic || 'Terjadi kesalahan',
          })
        }
      },
      onSettled: (data, _error, _variables, _context, mutation) => {
        const invalidateQueries = mutation.meta?.invalidateQueries as QueryKey | undefined
        const invalidateCondition = mutation.meta?.invalidateCondition as ((data: any) => boolean) | undefined
        const shouldInvalidate = invalidateCondition ? invalidateCondition(data) : true
        if (invalidateQueries && shouldInvalidate) {
          queryClient.invalidateQueries({ queryKey: invalidateQueries })
        }
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  })

  nuxtApp.vueApp.use(VueQueryPlugin, {
    queryClient,
  })

  // Provide queryClient to Nuxt app for access in stores/composables
  return {
    provide: {
      queryClient,
    },
  }
})
